var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.95806 16.6435H13.988C14.8468 16.6435 15.0194 16.033 14.9984 15.7278V8.05518C15.0236 7.39843 14.7352 7.19214 14.5879 7.17109L13.7354 6.44487V4.32938C13.7606 3.6221 13.1986 3.36109 12.9144 3.31899H3.18947C2.28012 3.26847 2.11593 3.97153 2.14751 4.32938V6.44487L1.32656 7.17109C0.998189 7.29738 0.979244 8.1078 1.01082 8.49722V15.7278C1.0866 16.4351 1.67388 16.6329 1.95806 16.6435Z",
    stroke: "#8A8A8A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.29492 7.26562L6.47315 12.6333",
    stroke: "#8A8A8A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15698 12.632L14.5878 7.39062",
    stroke: "#8A8A8A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.04199 5.37109H11.7462",
    stroke: "#8A8A8A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.13672 7.29688H11.5883",
    stroke: "#8A8A8A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.07349 9.0332H11.4619",
    stroke: "#8A8A8A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.16882 16.1689L7.23114 12.5694C7.46269 12.38 8.08365 12.1147 8.71514 12.5694L14.8722 16.1689",
    stroke: "#8A8A8A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.36816 3.06566L6.97847 1.45536C7.21001 1.15014 7.8815 0.691254 8.71507 1.29749L10.7674 3.22354",
    stroke: "#8A8A8A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2.14746 6.38086V7.48597",
    stroke: "#8A8A8A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7354 6.34961V7.51787",
    stroke: "#8A8A8A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.fb8b663669212cc8c42fc4cb36739bf0.svg";
export { ForwardRef as ReactComponent };